<template>
    <v-ons-list>
    </v-ons-list>
</template>

<script>
export default {
    props: ["spot"]
};
</script>